var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.219,
    height: 13.219,
    viewBox: "0 0 13.219 13.219",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326",
    transform: "translate(1726.1 -22861.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vectorsearch-1",
    d: "M4,5.1a.6.6,0,0,1-.424-.176L.538,1.887a.6.6,0,0,1,.849-.849L4.424,4.076A.6.6,0,0,1,4,5.1Z",
    transform: "translate(-1717.481 22870.02)",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vectorsearch",
    d: "M6.25,12.6A5.85,5.85,0,1,1,12.1,6.75,5.857,5.857,0,0,1,6.25,12.6Zm0-10.5A4.65,4.65,0,1,0,10.9,6.75,4.655,4.655,0,0,0,6.25,2.1Z",
    transform: "translate(-1726.5 22861)",
    fill: "#595959"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.4c3671f67e811b2f8bd0463f7e1a895f.svg";
export { ForwardRef as ReactComponent };